module.exports = __webpack_public_path__ + "img/social.46c5b078.png";